var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMymoveHorizontalLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 405.9 120.5",
    enableBackground: "new 0 0 405.9 120.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFA35C",
    points: "30.3,61.4 52.2,79.1 52.2,52 30.3,34.2  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#CAF100",
    points: "74.2,61.4 96.1,79.1 96.1,52 74.2,34.2  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCF6C",
    points: "74.2,61.4 52.2,79.1 52.2,52 74.2,34.2  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#EF4D77",
    points: "30.3,61.4 8.4,79.1 8.4,52 30.3,34.2  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFA35C",
    points: "30.3,25.6 52.2,43.4 52.2,25 30.3,7.2  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#CAF100",
    points: "74.2,25.6 96.1,43.4 96.1,25 74.2,7.2  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCF6C",
    points: "74.2,25.6 52.2,43.4 52.2,25 74.2,7.2  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#EF4D77",
    points: "30.3,25.6 8.4,43.4 8.4,25 30.3,7.2  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.4,77.8V40.8c0-5.2,3-8.2,8.2-8.2c4.4,0,6.8,1.8,8.6,6.4l10.3,26.2h0.3L160.1,39 c1.8-4.6,4.2-6.4,8.6-6.4c5.2,0,8.1,3,8.1,8.2v37.1c0,3.7-2,5.8-5.6,5.8c-3.5,0-5.5-2.1-5.5-5.8V52h-0.2l-11,27.3 c-0.9,2.3-2.4,3.4-4.8,3.4s-4-1.1-4.9-3.4l-11-27.3h-0.3v25.9c0,3.7-2,5.8-5.5,5.8C124.4,83.7,122.4,81.5,122.4,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M183.2,91.1c0-2.4,1.7-3.9,4.4-3.9c0.6,0,1,0,1.6,0c1.5,0,3.2-0.4,4.3-2.1l0.3-0.7L182.4,54 c-0.5-1.2-0.8-2.6-0.8-3.7c0-3.3,2.7-5.7,6.4-5.7c3.3,0,4.9,1.4,5.9,5l7,24h0.2l7-24.2c1-3.4,2.8-4.9,5.9-4.9 c3.5,0,5.9,2.3,5.9,5.4c0,1-0.3,2.5-0.7,3.7L209,82.6c-3.6,10.2-8.6,14.1-17.8,14.1C186,96.7,183.2,94.7,183.2,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M224.6,77.8V40.8c0-5.2,3-8.2,8.2-8.2c4.4,0,6.8,1.8,8.6,6.4l10.3,26.2h0.3L262.3,39 c1.8-4.6,4.2-6.4,8.6-6.4c5.2,0,8.1,3,8.1,8.2v37.1c0,3.7-2,5.8-5.6,5.8c-3.5,0-5.5-2.1-5.5-5.8V52h-0.2l-11,27.3 c-0.9,2.3-2.4,3.4-4.8,3.4s-4-1.1-4.9-3.4L236,52h-0.3v25.9c0,3.7-2,5.8-5.5,5.8C226.7,83.7,224.6,81.5,224.6,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M284.6,64.2c0-12.2,7.5-19.6,19.1-19.6c11.7,0,19.1,7.3,19.1,19.6c0,12.5-7.3,19.6-19.1,19.6 S284.6,76.6,284.6,64.2z M310.5,64.2c0-6.7-2.6-10.7-6.8-10.7c-4.1,0-6.8,4-6.8,10.7c0,6.8,2.6,10.6,6.8,10.6 C307.9,74.9,310.5,71,310.5,64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M334.5,77.4l-8.7-23.6c-0.4-1.1-0.7-2.4-0.7-3.7c0-3.3,2.7-5.4,6.1-5.4c3,0,5,1.6,5.8,4.9l6.3,23h0.2 l6.2-23.2c0.8-3.3,2.9-4.8,5.8-4.8c3.3,0,5.9,2.3,5.9,5.4c0,1.1-0.3,2.4-0.7,3.5l-8.7,23.9c-1.5,4.3-4.1,6.3-8.6,6.3 C338.6,83.7,336.1,81.8,334.5,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M363.4,64.4c0-12.1,7.2-19.8,18.6-19.8c11.1,0,18.4,7.4,18.4,17.4c0,3.1-1.8,4.8-4.9,4.8h-20.3v0.7 c0,4.5,3,7.6,7.4,7.6c3.3,0,5.6-1.1,8.3-3.8c1.3-1.2,2.3-1.6,3.8-1.6c2.5,0,4.6,1.6,4.6,4.3c0,0.9-0.3,1.9-0.8,2.7 c-2.5,4.4-8.5,7-16,7C370.5,83.8,363.4,76.5,363.4,64.4z M389,59.9c-0.2-4.1-2.9-6.7-6.7-6.7c-3.8,0-6.6,2.7-6.9,6.7H389z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#61A1FF",
    points: "52.3,89.1 52.3,116.2 96.1,80.8 79.2,67.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C400C6",
    points: "25.3,67.1 8.4,80.8 52.2,116.2 52.2,89.1 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymoveHorizontalLight);
export default __webpack_public_path__ + "static/media/mymove_horizontal_light.0c6b7a0fe49daf729962e55b323a5f15.svg";
export { ForwardRef as ReactComponent };